/**
 * Transforms a type/duration pair from grid format to API format
 *
 * @param typeValue - The type field value (e.g., "days", "months", "notIncluded")
 * @param durationValue - The duration field value
 * @param excludeDurationWhen - Type value(s) that should NOT include duration (default: ["notIncluded", "notOffered", "notApplicable"])
 */
export function transformTypeDurationToApi(
  typeValue: string | undefined,
  durationValue: number | undefined,
  excludeDurationWhen: string[] = [
    "notIncluded",
    "notOffered",
    "notApplicable",
  ],
): Record<string, unknown> {
  const type = typeValue ?? "notIncluded";
  const result: Record<string, unknown> = { type };

  if (!excludeDurationWhen.includes(type) && durationValue != null) {
    result["duration"] = durationValue;
  }

  return result;
}

/**
 * Transforms a type/duration pair from API format to grid format
 *
 * @param apiObject - The nested API object (e.g., { type: "days", duration: 30 })
 * @param prefix - The field name prefix for the flat fields (e.g., "waitingPeriod")
 */
export function transformTypeDurationFromApi(
  apiObject: { type?: string; duration?: number } | null | undefined,
  prefix: string,
): Record<string, unknown> {
  const typeKey = `${prefix}Type`;
  const durationKey = `${prefix}Duration`;

  if (apiObject && typeof apiObject === "object") {
    return {
      [typeKey]: apiObject.type,
      [durationKey]: apiObject.duration,
    };
  }

  return {
    [typeKey]: undefined,
    [durationKey]: undefined,
  };
}
